import constants from '../constants';

export const onChange = (name: string, value: string) => ({
  type: constants.ON_CHANGE,
  payload: { name, value },
});

export const highlightErrors = (errors: any, name: string) => ({
  type: constants.HIGHLIGHT_ERRORS,
  payload: { errors, name },
});

export const onSubmitSuccess = () => ({
  type: constants.PROMISE_SUBMIT_SUCCESS,
});

export const onSubmitError = () => ({
  type: constants.PROMISE_SUBMIT_ERROR,
});
